module.exports = __webpack_public_path__ + "img/ht_icon_stack.3d83c59d.svg";